import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs"
import { FilesTab } from "./FilesTab"
import { AppearanceTab } from "./AppearanceTab"
import { AccountTab } from "./AccountTab"
import { ApiTab } from "./ApiTab"

export interface FrontMatterField {
  id: number
  name: string
  position: number
  options: { id: number; label: string; position: number }[]
}

export interface RoutingRule {
  id: number
  front_matter_field_id: number
  front_matter_option_id: number
  destination_folder: string
  field_name: string
  option_label: string
}

export interface UserSettings {
  root_folder: string
  default_destination: string
  images_folder: string
  text_notes_destination: string
  voice_notes_destination: string
  uploads_destination: string
  file_name_template: string
  save_audio_to_dropbox: boolean
  audio_retention_period: string
  theme_mode: "light" | "dark" | "system"
  primary_color: string
  secondary_color: string
  heading_font: string
  body_font: string
}

interface SettingsPageProps {
  settings: UserSettings
  frontMatterFields: FrontMatterField[]
  routingRules: RoutingRule[]
  dropboxConnected: boolean
  hasApiToken: boolean
  baseUrl: string
  email: string
}

export function SettingsPage({
  settings,
  frontMatterFields,
  routingRules,
  dropboxConnected,
  hasApiToken,
  baseUrl,
  email,
}: SettingsPageProps) {
  return (
    <div className="mx-auto w-full max-w-3xl lg:max-w-5xl p-6">
      <h1 className="mb-6 text-2xl font-bold">Settings</h1>
      <Tabs defaultValue="files">
        <TabsList className="mb-6 w-full justify-start">
          <TabsTrigger value="files">Files</TabsTrigger>
          <TabsTrigger value="appearance">Appearance</TabsTrigger>
          <TabsTrigger value="account">Account</TabsTrigger>
          <TabsTrigger value="api">API</TabsTrigger>
        </TabsList>

        <TabsContent value="files">
          <FilesTab
            settings={settings}
            dropboxConnected={dropboxConnected}
            fields={frontMatterFields}
            routingRules={routingRules}
          />
        </TabsContent>

        <TabsContent value="appearance">
          <AppearanceTab settings={settings} />
        </TabsContent>

        <TabsContent value="account">
          <AccountTab email={email} />
        </TabsContent>

        <TabsContent value="api">
          <ApiTab hasToken={hasApiToken} baseUrl={baseUrl} />
        </TabsContent>
      </Tabs>
    </div>
  )
}
